import { objectToCamelCase, objectToSnakeCase } from '@/services/utils'

import api from './api'

export default class MessageTemplate {
  static api = api.create(MessageTemplate)

  constructor(json) {
    Object.assign(this, { ...json })
  }

  static create(opts) {
    return new MessageTemplate(opts)
  }

  static fromAPI(json) {
    return new MessageTemplate(objectToCamelCase(json))
  }

  // Will need a toAPI if a post endpoint is needed
}
